<template>
  <el-drawer
    title="出入场弹框"
    :visible.sync="showOrderInfo"
    :modal="false"
    @close="closeDrawer"
  >
    <div style="position: relative;">
      <el-image :src="require('@/assets/img/nodata02@2x.png')" alt="" style="width: 100%;"></el-image>
      <div class="drawBox">
        <tabSelect :showPassIn="Boolean(settingConfig.ShowPassIn)" @change="tabChange"></tabSelect>
        <pay-order-card :height="rightHeight - 228" v-if="tabDirection === 2" @pupNewOrder="tabChange" />
        <park-in-card
          v-else-if="tabDirection === 1"
          :bulletPlateSize="settingConfig.BulletPlateSize"
          :bulletPlateColor="settingConfig.BulletPlateColor"
          :showPassIn="settingConfig.ShowPassIn"
          @pupBlackParkIn="tabChange"></park-in-card>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import tabSelect from "@/serviceComponents/tabSelectNew";
import { getChargingPopUp } from "@/utils/service";
// 离场支付订单
import payOrderCard from "./payOrderCard";
import parkInCard from "./parkInCard";
import { orderPubSub, blackParkInPubSub } from "@/service/pubsub/index";

export default {
  props: {
    rightHeight: [String, Number]
  },
  components: {
    tabSelect,
    payOrderCard,
    parkInCard,
  },
  data() {
    return {
      tabDirection: 2,
    }
  },
  computed: {
    showOrderInfo: {
      get () {
        return this.$store.state.order.showOrderDetail || false
      },
      set (value) {
        this.$store.dispatch('GetShowOrderDetail', value)
      }
    },
    settingConfig: function () {
      return JSON.stringify(this.$store.state.layout.settingConfig) === '{}' ? JSON.parse(getChargingPopUp()) : this.$store.state.layout.settingConfig;
    },
    gateIdArr: function () {
      return this.$store.state.order.gateIds ? this.$store.state.order.gateIds : [];
    },
    gateId: function () {
      return this.$store.state.order.tabsGateId ? parseInt(this.$store.state.order.tabsGateId) : parseInt(sessionStorage.getItem('OutGateId'));
    },
    moreBlackParkIn: function () {
      return this.$store.state.order.moreBlackParkIn
    },
  },
  watch: {
    gateIdArr: 'checkActiveTabs',
    showOrderInfo: 'checkActiveTabs'
  },
  mounted() {
    // console.log(this.gateId);
  },
  methods: {
    showLeaveQuery() {
      this.$store.dispatch("GetShowOrderDetail", true);
    },
    closeDrawer() {
      this.$store.dispatch("GetShowOrderDetail", false);
    },
    tabChange(data) {
      this.tabDirection = data.Direction;
      // console.log(data.showOrderInfoCheck);
      this.$store.dispatch("SetTabsGateId", String(data.Id));
      this.$store.dispatch("SetPayOrderGateId", data.Id);
      // console.log('tabChange', this.OutGateId)
      if (data.Direction === 2) {
        // console.log('tabChange', data)
        let leftArr = JSON.parse(this.$store.state.order.leftGateIdTabs);
        let arr = leftArr.filter(v => {return v.Id === data.Id});
        data = arr.length > 0 ? arr[0] : data;
        setTimeout(() => {
          orderPubSub.publish(data.orderId ? {id: data.orderId, park_lot_gate_id: String(data.Id)} : {id: -1});
        }, 50)
      } else {
        let arr = this.moreBlackParkIn[data.SentryBoxId].filter(v => {return v.park_lot_gate_id === String(data.Id)}).filter(v => {return v.message_type !== '5' && v.message_type !== '32'});
        // console.log(!data.showOrderInfoCheck, arr.length, this.settingConfig.ShowPassIn)
        if (!data.showOrderInfoCheck || arr.length > 0) {
          setTimeout(() => {
            blackParkInPubSub.publish(arr[0]);
          }, 50)
        }
      }
      this.$forceUpdate();
    },
    checkActiveTabs() {
      if (this.gateIdArr.length > 0 && this.showOrderInfo) {
        let arr = this.gateIdArr.filter(v => {return v.Id === this.gateId})
        // console.log(arr)
        if (arr.length > 0) {
          arr[0].showOrderInfoCheck = true;
          this.tabChange(arr[0]);
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
